"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Active = _interopRequireDefault(require("./states/Active"));
var _Banned = _interopRequireDefault(require("./states/Banned"));
var _Error = _interopRequireDefault(require("./states/Error"));
var _Default = _interopRequireDefault(require("./states/Default"));
var _Calling = _interopRequireDefault(require("./states/Calling"));
var _States = _interopRequireDefault(require("./States"));
var _AudioPlayer = _interopRequireDefault(require("../AudioPlayer"));
var _sounds = require("../../constants/sounds");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var AudioStatus = _AudioPlayer["default"].Status;
var Dialer = /*#__PURE__*/function (_React$PureComponent) {
  function Dialer() {
    (0, _classCallCheck2["default"])(this, Dialer);
    return _callSuper(this, Dialer, arguments);
  }
  (0, _inherits2["default"])(Dialer, _React$PureComponent);
  return (0, _createClass2["default"])(Dialer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        calls = _this$props.calls,
        contact = _this$props.contact,
        departments = _this$props.departments,
        isDeanonymised = _this$props.isDeanonymised,
        isHold = _this$props.isHold,
        isInterception = _this$props.isInterception,
        isMaster = _this$props.isMaster,
        isRequestingHelp = _this$props.isRequestingHelp,
        isSupervising = _this$props.isSupervising,
        isSupervisor = _this$props.isSupervisor,
        isTransfering = _this$props.isTransfering,
        isVoteNeed = _this$props.isVoteNeed,
        onAnswer = _this$props.onAnswer,
        onCall = _this$props.onCall,
        onCancelHelpRequest = _this$props.onCancelHelpRequest,
        onConnectSupervisor = _this$props.onConnectSupervisor,
        onDeaninomize = _this$props.onDeaninomize,
        onDepartmentsToggle = _this$props.onDepartmentsToggle,
        onHangup = _this$props.onHangup,
        onHold = _this$props.onHold,
        onListen = _this$props.onListen,
        onOperatorsToggle = _this$props.onOperatorsToggle,
        onRecentCallsToggle = _this$props.onRecentCallsToggle,
        onRequestHelp = _this$props.onRequestHelp,
        onTone = _this$props.onTone,
        onTransfer = _this$props.onTransfer,
        onUnban = _this$props.onUnban,
        onWithdraw = _this$props.onWithdraw,
        onOpenCall = _this$props.onOpenCall,
        operators = _this$props.operators,
        state = _this$props.state,
        error = _this$props.error,
        serverError = _this$props.serverError;
      if (error) {
        return /*#__PURE__*/_react["default"].createElement(_Error["default"], {
          error: error
        });
      }
      return /*#__PURE__*/_react["default"].createElement(StyledDialer, this.props, !Dialer.isCalling(state) && ![_States["default"].BANNED, _States["default"].ERROR].includes(state) && /*#__PURE__*/_react["default"].createElement(StyledDefaultState, {
        calls: calls,
        onCall: onCall,
        onListen: onListen,
        onOperatorsToggle: onOperatorsToggle,
        onRecentCallsToggle: onRecentCallsToggle,
        operators: operators,
        state: state
      }), state === _States["default"].INCOMING && /*#__PURE__*/_react["default"].createElement(_Calling["default"], {
        contact: contact,
        onSubmit: onAnswer,
        isInterception: isInterception
      }), state === _States["default"].IN_SERVICE && /*#__PURE__*/_react["default"].createElement(StyledActiveState, {
        state: state,
        operators: operators,
        isHold: isHold,
        isDeanonymised: isDeanonymised,
        isInterception: isInterception,
        isTransfering: isTransfering,
        isSupervising: isSupervising,
        isSupervisor: isSupervisor,
        isRequestingHelp: isRequestingHelp,
        isVoteNeed: isVoteNeed,
        serverError: serverError,
        contact: contact,
        onHangup: onHangup,
        onHold: onHold,
        onTone: onTone,
        onTransfer: onTransfer,
        onWithdraw: onWithdraw,
        onRequestHelp: onRequestHelp,
        onCancelHelpRequest: onCancelHelpRequest,
        onConnectSupervisor: onConnectSupervisor,
        onDeaninomize: onDeaninomize,
        departments: departments,
        onOperatorsToggle: onOperatorsToggle,
        onDepartmentsToggle: onDepartmentsToggle,
        onOpenCall: onOpenCall
      }), state === _States["default"].OUTGOING && /*#__PURE__*/_react["default"].createElement(_Calling["default"], {
        contact: contact,
        onSubmit: onHangup,
        type: _States["default"].OUTGOING
      }), state === _States["default"].BANNED && /*#__PURE__*/_react["default"].createElement(_Banned["default"], {
        onSubmit: onUnban
      }), isMaster && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_AudioPlayer["default"], {
        loop: true,
        autoLoad: true,
        playStatus: isHold ? AudioStatus.PLAYING : AudioStatus.STOPPED,
        url: _sounds.HOLD_SOUND
      }), /*#__PURE__*/_react["default"].createElement(_AudioPlayer["default"], {
        loop: true,
        autoLoad: true,
        playStatus: state === _States["default"].INCOMING ? AudioStatus.PLAYING : AudioStatus.STOPPED,
        url: _sounds.INCOMING_SOUND
      }), /*#__PURE__*/_react["default"].createElement(_AudioPlayer["default"], {
        loop: true,
        autoLoad: true,
        playStatus: state === _States["default"].OUTGOING ? AudioStatus.PLAYING : AudioStatus.STOPPED,
        url: _sounds.OUTGOING_SOUND
      }), /*#__PURE__*/_react["default"].createElement(_AudioPlayer["default"], {
        loop: true,
        autoLoad: true,
        playStatus: isTransfering ? AudioStatus.PLAYING : AudioStatus.STOPPED,
        url: _sounds.TRANSFER_SOUND
      })));
    }
  }], [{
    key: "isCalling",
    value: function isCalling(state) {
      return [_States["default"].INCOMING, _States["default"].IN_SERVICE, _States["default"].OUTGOING].includes(state);
    }
  }, {
    key: "isBanned",
    value: function isBanned(state) {
      return _States["default"].BANNED === state;
    }
  }]);
}(_react["default"].PureComponent);
Dialer.propTypes = {
  className: _propTypes["default"].string,
  state: _propTypes["default"].oneOf(Object.values(_States["default"])),
  contact: _propTypes["default"].shape({
    fullName: _propTypes["default"].string,
    number: _propTypes["default"].number
  }),
  error: _propTypes["default"].string,
  departments: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].number.isRequired,
    svg: _propTypes["default"].object,
    isReserve: _propTypes["default"].bool,
    value: _propTypes["default"].string.isRequired
  })).isRequired,
  operators: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    call: _propTypes["default"].shape({
      id: _propTypes["default"].string,
      duration: _propTypes["default"].number
    }),
    contact: _propTypes["default"].shape({
      name: _propTypes["default"].string,
      number: _propTypes["default"].number,
      isHidden: _propTypes["default"].bool
    }),
    operator: _propTypes["default"].shape({
      name: _propTypes["default"].string.isRequired,
      number: _propTypes["default"].string.isRequired,
      skillGroups: _propTypes["default"].arrayOf(_propTypes["default"].string),
      canCall: _propTypes["default"].bool.isRequired,
      canTransfer: _propTypes["default"].bool.isRequired,
      canListen: _propTypes["default"].bool.isRequired,
      canRequestHelp: _propTypes["default"].bool.isRequired
    }).isRequired,
    state: _propTypes["default"].string
  })),
  calls: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    number: _propTypes["default"].number.isRequire
  })),
  isDeanonymised: _propTypes["default"].bool,
  isHold: _propTypes["default"].bool,
  isInterception: _propTypes["default"].bool,
  isMaster: _propTypes["default"].bool,
  isRequestingHelp: _propTypes["default"].bool,
  isSupervising: _propTypes["default"].bool,
  isSupervisor: _propTypes["default"].bool,
  isTransfering: _propTypes["default"].bool,
  isVoteNeed: _propTypes["default"].bool,
  serverError: _propTypes["default"].bool,
  onAnswer: _propTypes["default"].func,
  onAuth: _propTypes["default"].func,
  onCall: _propTypes["default"].func,
  onCalling: _propTypes["default"].func,
  onCancelHelpRequest: _propTypes["default"].func,
  onConnectSupervisor: _propTypes["default"].func,
  onDeaninomize: _propTypes["default"].func,
  onDepartmentsToggle: _propTypes["default"].func,
  onHangup: _propTypes["default"].func,
  onHold: _propTypes["default"].func,
  onListen: _propTypes["default"].func,
  onOperatorsToggle: _propTypes["default"].func,
  onRecentCallsToggle: _propTypes["default"].func,
  onRequestHelp: _propTypes["default"].func,
  onTone: _propTypes["default"].func,
  onTransfer: _propTypes["default"].func,
  onUnban: _propTypes["default"].func,
  onWithdraw: _propTypes["default"].func,
  onOpenCall: _propTypes["default"].func
};
Dialer.defaultProps = {
  calls: null,
  className: '',
  contact: null,
  isDeanonymised: false,
  isHold: false,
  isInterception: false,
  isMaster: false,
  isRequestingHelp: false,
  isSupervising: false,
  isSupervisor: false,
  isTransfering: false,
  isVoteNeed: false,
  onAnswer: Function.prototype,
  onAuth: Function.prototype,
  onCall: Function.prototype,
  onCalling: Function.prototype,
  onCancelHelpRequest: Function.prototype,
  onConnectSupervisor: Function.prototype,
  onDeaninomize: Function.prototype,
  onDepartmentsToggle: Function.prototype,
  onHangup: Function.prototype,
  onHold: Function.prototype,
  onListen: Function.prototype,
  onOperatorsToggle: Function.prototype,
  onRecentCallsToggle: Function.prototype,
  onRequestHelp: Function.prototype,
  onTone: Function.prototype,
  onTransfer: Function.prototype,
  onUnban: Function.prototype,
  onWithdraw: Function.prototype,
  onOpenCall: Function.prototype,
  operators: null,
  state: _States["default"].OFFLINE,
  error: null,
  serverError: null
};
var StyledDialer = _styledComponents["default"].div.withConfig({
  displayName: "Dialer__StyledDialer",
  componentId: "sc-vxrf95-0"
})(["width:100%;height:65px;display:flex;font-size:14px;align-items:center;background-color:#262729;justify-content:space-between;"]);
var StyledActiveState = (0, _styledComponents["default"])(_Active["default"]).withConfig({
  displayName: "Dialer__StyledActiveState",
  componentId: "sc-vxrf95-1"
})(["margin-left:10px;"]);
var StyledDefaultState = (0, _styledComponents["default"])(_Default["default"]).withConfig({
  displayName: "Dialer__StyledDefaultState",
  componentId: "sc-vxrf95-2"
})(["margin-left:10px;"]);
Dialer.States = _States["default"];
var _default = exports["default"] = Dialer;